import { MetaReducer } from "@ngrx/store";
import { clearState } from "@core/global-state/clear/clearState.reducer";
import { localStorageSyncReducer } from "../ngrx";

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer, clearState];